"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetApolloClient = void 0;
const react_1 = require("react");
const client_1 = require("@apollo/client");
const apollo_client_utils_1 = require("./apollo-client.utils");
const context_1 = require("../context");
const hooks_1 = require("../hooks");
const utils_1 = require("../utils");
const useGetApolloClient = () => {
    const url = (0, utils_1.useGetEnrichAiAPIUrl)();
    const token = (0, hooks_1.useToken)();
    const { config, logError } = (0, react_1.useContext)(context_1.EnrichContext);
    // We want to avoid cleaning the cache on every token change so we create and store it separately.
    const cache = (0, react_1.useRef)(new client_1.InMemoryCache());
    const client = (0, react_1.useMemo)(() => (0, apollo_client_utils_1.createApolloClient)(url, {
        token, isNonPublicEnv: config.isNonPublicEnv, logError, cache: cache.current,
    }), [token, url, config.isNonPublicEnv, logError]);
    return client;
};
exports.useGetApolloClient = useGetApolloClient;
exports.default = exports.useGetApolloClient;
